export enum AttributeValueType {
  STRING = 'STRING',
  ENUM = 'ENUM',
  ENUMLIST = 'ENUMLIST',
  REF = 'REF',
  REFLIST = 'REFLIST',
  BOOLEAN = 'BOOLEAN'
}
